class TokenLetter {

  constructor() {}

  init() {
    this.$form = document.getElementById('token-letter-form');
    if (!this.$form) return;
    this.$content = document.getElementById('token-letter-content');
    this.$processFormatting = document.getElementById('process-formatting');
    this.$contact = document.getElementById('person_company');
    this.persons = persons;
    this.updatePersonFields();
  }

  setupEvents() {
    if (!this.$form) return;

    this.$form.addEventListener('submit', e => this.generateTokenFields(e));

    this.$contact.addEventListener('change', e => this.updatePersonFields());

    this.$form.querySelectorAll('[contenteditable=true]')
      .forEach(elem => {
        elem.addEventListener('focus', e => this.selectTokenText(e));
        elem.addEventListener('blur', e => this.restoreEmptyTokenText(e));
      });

    this.$form.querySelectorAll('.clear-token')
      .forEach(elem => {
        elem.addEventListener('click', e => this.clearTokenText(e));
      });
  }

  /**
   * Replace person fields by current selected contact data.
   */
  updatePersonFields() {
    let person = this.persons[this.$contact.value];
    document.getElementById('person_name').textContent = person.name;
    document.getElementById('person_address1').textContent = person.address1;
    document.getElementById('person_address2').textContent = person.address2;
    document.getElementById('person_cityStateZip').textContent = person.cityStateZip;
  }

  /**
   * Create hidden input field for every editable content token to be passed as POST variable.
   */
  generateTokenFields(e) {
    this.$form.querySelectorAll('[contenteditable=true]')
      .forEach(elem => {
        let token = elem.dataset.token;

        this.$content.querySelectorAll('input[name="inline_token[' + token + ']"]')
          .forEach(e => e.parentNode.removeChild(e));

        let $hidden = document.createElement('input');
        $hidden.type = 'hidden';
        $hidden.name = 'inline_token[' + token + ']';
        if (elem.textContent !== '[empty]') $hidden.value =
          (this.$processFormatting.checked ? elem.innerHTML : elem.textContent);

        this.$content.appendChild($hidden);
      });
  }

  /**
   * Select token text on focus event.
   */
  selectTokenText(e) {
    window.setTimeout(function () {
      document.execCommand('selectAll', false, null);
    });
  }

  /**
   * Restore token text if cleared on blur event.
   */
  restoreEmptyTokenText(e) {
    let text = e.target.textContent.trim();
    let placeholder = e.target.dataset.placeholder.trim();
    if (text.length === 0) {
      e.target.textContent = placeholder;
    }
  }

  /**
   * Clear token text on "x" button click event.
   */
  clearTokenText(e) {
    let token = e.target.dataset.token;
    document.getElementById('inline_token_' + token).textContent = '[empty]';
  }


  load() {
    this.init();
    this.setupEvents();
  }
}

export default new TokenLetter();

